























import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'
import UtxoRow from '@/components/Transaction/UtxoRow.vue'
import { Transaction } from '@/js/Transaction'
import { getMappingForType } from '@/store/modules/transactions/maps'
import { toAVAX } from '@/helper'
import Tooltip from '@/components/rows/Tooltip.vue'
import Metadata from '@/components/Transaction/Metadata.vue'

@Component({
    components: {
        UtxoRow,
        Tooltip,
        CopyText,

        Metadata,
    },
    filters: {
        getType: getMappingForType,
        toAVAX,
    },
})
export default class TransactionSummary extends Vue {
    @Prop() tx!: Transaction

    get isMemo(): boolean {
        return this.tx.memo === '' || null ? false : true
    }

    get isAssetGenesis(): boolean {
        return this.tx.type === 'create_asset'
    }

    get isStaking() {
        return this.tx.type === 'add_validator' ||
            this.tx.type === 'add_delegator'
            ? true
            : false
    }

    copy() {
        navigator.clipboard.writeText(this.tx.id)
        this.$store.dispatch('Notifications/add', {
            title: 'Copied',
            message: 'Copied to clipoard.',
        })
    }
}
